import { useContext } from "react";

import ProjectContext from "../context/ProjectContext";

export default function useCurrentProject() {
    return useContext(ProjectContext);
}
